// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiArrowUp } from 'react-icons/fi';
import logo from '../assets/logo-cio-light.png';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-primary-900 text-white pt-14 pb-8">
      <div className="container-page grid md:grid-cols-3 gap-10">
        <div>
          <img src={logo} alt="Logo CIO" className="h-20 w-auto mb-5" />
          <p className="text-sm text-white/70 leading-relaxed">
            Soluciones integrales de ingeniería, construcción y servicios petroleros para el desarrollo
            de la infraestructura energética.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-accent-400">Navegación</h3>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-white/70 hover:text-white transition">Inicio</Link></li>
            <li><Link to="/servicios" className="text-white/70 hover:text-white transition">Servicios</Link></li>
            <li><Link to="/nosotros" className="text-white/70 hover:text-white transition">Nosotros</Link></li>
            <li><Link to="/contacto" className="text-white/70 hover:text-white transition">Contacto</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-accent-400">Contacto</h3>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2.5">
              <FiMapPin className="w-4 h-4 mt-0.5 text-accent-400 shrink-0" />
              Av. 2 El Milagro, C.C. Lago Mall, Nivel 3 Local MZO-3, Maracaibo
            </li>
            <li className="flex items-start gap-2.5">
              <FiPhone className="w-4 h-4 mt-0.5 text-accent-400 shrink-0" />
              +58 424-6859736
            </li>
            <li className="flex items-start gap-2.5">
              <FiMail className="w-4 h-4 mt-0.5 text-accent-400 shrink-0" />
              transarca.operaciones@gmail.com
            </li>
          </ul>
        </div>
      </div>

      <div className="container-page mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50">
          © {new Date().getFullYear()} Corporación Industrial de Occidente, C.A. Todos los derechos reservados.
        </p>
        <button
          onClick={scrollTop}
          className="inline-flex items-center gap-2 text-xs text-white/70 hover:text-white transition"
        >
          Volver arriba
          <FiArrowUp className="w-4 h-4" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
